export default {
    name: "Citrix Workspace",
    currency: "USD",
    editions: {
        "Workspace Essentials": {
            rate: 2,
            tiers: {
                "1-100": 48,
                "101-250": 40,
                "251-1000": 30,
                "1001-2500" : 30
            }
        },
        "Workspace Standard": {
            rate: 7,
            tiers: {
                "1-100": 144,
                "101-250": 115,
                "251-1000": 95,
                "1001-2500" : 80
            }
        },
        "Workspace Premium": {
            rate: 18,
            tiers: {
                "1-100": 360,
                "101-250": 290,
                "251-1000": 235,
                "1001-2500" : 200
            }
        },
        "Workspace Premium Plus": {
            rate: 25,
            tiers: {
                "1-100": 500,
                "101-250": 400,
                "251-1000": 325,
                "1001-2500" : 275
            }
        }
    },
    formatNumber: function(num){
        return "$"+num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getCost: function(edition, users, discount, term){
        if(isNaN(users)){
            return 0
        }
        if(this.editions.hasOwnProperty(edition)) {
            let percentage = (100 - discount) / 100
            let cost = 0,
                _edition = this.editions[edition]
            let tiers = Object.keys(_edition.tiers)
            for (const tier of tiers) {
                let range = tier.split("-").map(function(num){
                    return parseInt(num)
                }), max = 0
                if(range[0] <= users && users <= range[1]){
                    max = users
                }else if(users > range[1]){
                    max = range[1]
                }else{
                    break
                }
                cost += _edition.tiers[tier]*((max+1) - range[0])
            }
            //cost = (((cost*percentage)*term)/(12*term)).toFixed(2)
            cost = (((cost*percentage)*term)/(12*term)/users).toFixed(2)
            return this.formatNumber(cost)

        }
    }
}